import PublicRepository from './publicRepository';
import AuthRepository from './authRepository';
import UtilityRepository from './utilityRepository';
import MerchantRepository from './merchantRepository';
import DashboardRepository from './dashboardRepository';
import MerchantRoleRepository from './merchantRoleRepository';
import UserRepository from './userRepository';
import EmailTemplateRepository from './emailTemplateRepository';
import AMLRepository from './amlrepository';
import AgentRepository from './agentsRepository';
import NotificationRepositry from './notificationRepository';
import CaseRepositry from './caseRepository';
import M2MRepositry from './m2mRepository';
import DevsRepositry from './devsRepository';
import CfmRepository from './cfmRepository';
import WebhooksRepository from './webhooksRepository';
import TemplateRepository from './templatesRepository';
import triggersRepository from './triggerRepository';
import loginAttemptRepository from './loginAttemptRepository';
import userPreferences from './userPreferences';
import TwoFARepository from './twoFARepository';
import dashboardSettings from './dashboardSettings';
import arhiveRequests from './arhiveRequests';
import billingRepository from './billingRepository';
import paymentsRepository from './paymentsRepository';
import formRepository from './formRepository';
import formSubmissionRepository from './formSubmissionRepository';

const repositories = {
	public: PublicRepository,
	auth: AuthRepository,
	utility: UtilityRepository,
	merchant: MerchantRepository,
	merchantRole: MerchantRoleRepository,
	user: UserRepository,
	emailTemplate: EmailTemplateRepository,
	aml: AMLRepository,
	dashboard: DashboardRepository,
	dashboardSettings: dashboardSettings,
	agent: AgentRepository,
	notification: NotificationRepositry,
	case: CaseRepositry,
	m2m: M2MRepositry,
	devs: DevsRepositry,
	cfm: CfmRepository,
	webhooks: WebhooksRepository,
	template: TemplateRepository,
	triggers: triggersRepository,
	loginAttempt: loginAttemptRepository,
	userPreferences: userPreferences,
	twoFA: TwoFARepository,
	archiveRequestsRepository: arhiveRequests,
	billing: billingRepository,
	payments: paymentsRepository,
	form: formRepository,
	formSubmission: formSubmissionRepository,
};

export const RepositoryFactory = {
	get: (name) => repositories[name],
};
